const CREATED = 1;
const EXECUTED = 10;

export default {
  CREATED,
  EXECUTED
};
